module.exports = __webpack_public_path__ + "img/box6-01.ac4dba25.png";